import { supabase as defaultSupabase } from "@/services/supabaseClient";

async function invokePhoto(client,options){const controller=new AbortController();const timer=setTimeout(()=>controller.abort(),8000);try{return await client.functions.invoke('patient-photo-access',{...options,signal:controller.signal});}finally{clearTimeout(timer);}}

// Only the appointment-scoped EHR authority may select the Patient/gallery.
// Route state, local caches, arbitrary URLs and profile avatars are not evidence
// of Patient consent and must never become clinical gallery candidates.
export async function loadDoctorPatientPhotos({ appointmentId, appointmentSnapshot = null, previousItems=[], supabase=defaultSupabase }) {
  const id = appointmentId || appointmentSnapshot?.appointmentId || appointmentSnapshot?.id;
  const empty = { patientUserId: null, items: [], access: "unavailable" };
  if (!id) return empty;
  try {

    const { data, error } = await invokePhoto(supabase, {body:{action:'list',appointment_id:id}});
    if (error) return { ...empty, access: error.context?.status === 403 ? 'required' : 'unavailable' };
    const patientUserId=data?.patient_user_id;
    if(!patientUserId)return empty;
    const paths=[...new Set(Array.isArray(data.paths)?data.paths:[])];
    if(paths.length===previousItems.length&&paths.every((path,i)=>path===previousItems[i]?.path))return {patientUserId,items:previousItems,access:"granted"};
    const created=[];
    try {
      for(const path of paths){
        const {data:blob,error:readError}=await invokePhoto(supabase,{body:{action:'read',appointment_id:id,path}});
        if(readError||!(blob instanceof Blob))throw Error('Photo access unavailable');
        created.push({id:path,path,url:URL.createObjectURL(blob),source:'patient_profile',bucket:'patient-photos'});
      }
    }catch(error){created.forEach(item=>URL.revokeObjectURL(item.url));throw error;}
    const items=created;
    return { patientUserId, items, access: "granted" };
  } catch {
    return empty;
  }
}

export function releaseDoctorPatientPhotos(items=[]){for(const item of items)if(item?.url?.startsWith('blob:'))URL.revokeObjectURL(item.url);}
